import { SquareOpacityIcon } from './SquareOpacityIcon';

/**
 * author: Michael Irigoyen
 * id 6F9AA4F8-ECC6-495E-87C0-84DCE1327F4D
 * name square-opacity
 * version: 6.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/square-opacity.svg
 * tags
 * - Drawing / Art 
 * - Shape 
 */
export const SquareTransparentIcon = SquareOpacityIcon;
export default SquareTransparentIcon